import { Injectable, HostListener } from '@angular/core';

import swal from 'sweetalert2';

@Injectable()
export class UiService {

  public showSidebar = true;
  private _count = 0;
  private _loaderCounter = 0;
  get loaderState() {
    return this._loaderCounter !== 0;
  }

  public loader = {
    show: () => {
      console.log('loader_show');
      this._loaderCounter++;
    },
    hide: () => {
      console.log('loader_hide');
      this._loaderCounter--;
    },
    reset: () => {
      console.log('loader_reset');
      this._loaderCounter = 0;
    }
  }

  public unreadCount = 0;

  public alert = {
    error: (message) => {
      swal('Oops!', message, 'error');
    }
  }

  constructor() { }

  getLoaderState() {
    return this._loaderCounter;
  }

}



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/services/ui/ui.service.ts